import React, { FC } from 'react';

const Layout: FC = function Layout({ children }) {
  return <main>{children}</main>;
};

export default Layout;
